import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/alpine'
import './modules/carousel'
import './modules/filters'
import './modules/gsap'
import './modules/svgIconSprite'
import './modules/video-fit'
//import form from './modules/form';

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
		//form();
	}, 100);
});
